import OrderForm from './OrderForm';
import connect from './connect';

export default connect(OrderForm);



// WEBPACK FOOTER //
// ./src/components/OrderForm/index.js